import mitt, { type Emitter } from 'mitt';

import type { DiscoverMWMoveEvents } from './DiscoverMWMove.types';

export const DiscoverMWMoveEmitter: Emitter<DiscoverMWMoveEvents> = mitt();
